"use client";
import { ProgressLoader } from 'nextjs-progressloader'
import React from 'react'

export const ProgressBar = () => {
  return (
    <> <ProgressLoader/></>
  )
}
